var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTailwind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.3902,
    height: 64.3902,
    rx: 8,
    fill: "url(#paint0_linear_45_233)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 18C26.4925 18 22.7575 21.0479 21.25 27.1667C23.5 24.1188 26.1325 22.9729 29.125 23.7292C30.835 24.1646 32.0725 25.425 33.4225 26.8229C35.6275 29.1146 38.125 31.75 43.75 31.75C49.7575 31.75 53.4925 28.7021 55 22.5833C52.75 25.6313 50.1175 26.7771 47.125 26.0208C45.415 25.5854 44.2 24.325 42.8275 22.9271C40.6225 20.6354 38.125 18 32.5 18ZM21.25 31.75C15.2425 31.75 11.5075 34.7979 10 40.9167C12.25 37.8688 14.8825 36.7229 17.875 37.4792C19.585 37.9146 20.8 39.175 22.1725 40.5729C24.3775 42.8646 26.875 45.5 32.5 45.5C38.5075 45.5 42.2425 42.4521 43.75 36.3333C41.5 39.3813 38.8675 40.5271 35.875 39.7708C34.165 39.3354 32.95 38.075 31.5775 36.6771C29.3725 34.3854 26.875 31.75 21.25 31.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_233",
    x1: -4.02439,
    y1: -6.03659,
    x2: 59.0244,
    y2: 72.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTailwind);
export default __webpack_public_path__ + "static/media/icon_tailwind.b7571131fb3b5ae7f1331a53054b731a.svg";
export { ForwardRef as ReactComponent };